import { connect } from 'react-redux';
import { instantQuotePriceSummarySelector } from '../../../../../redux/instant-quote/instant-quote.selectors';
import { PriceSummary as PriceSummaryComponent } from './price-summary';
export const PriceSummary = connect(instantQuotePriceSummarySelector)(PriceSummaryComponent);